export default __webpack_public_path__ + "static/media/group.6811e127.png";